import { render, staticRenderFns } from "./groupForm.vue?vue&type=template&id=3972ab88&scoped=true"
import script from "./groupForm.vue?vue&type=script&lang=js"
export * from "./groupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3972ab88",
  null
  
)

export default component.exports